<img [src]="src()" [alt]="alt()" [class]="imgClass()" />
